"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/lib/auth-context";
import { useEffect, useState, useCallback } from "react";
import { PageLoader } from "./components/page-loader";
import { InsightsCard } from "./components/insights-card";
interface Usage {
  interactionCount: number;
  notificationCount: number;
  limits: {
    maxInteractionsPerMonth: number;
    maxDashboards: number;
    maxAlerts: number;
  };
}
interface InviteCode {
  codeId: string;
  code: string;
  isUsed: boolean;
  createdDate: string;
  usedDate: string | null;
}
export default function DashboardPage() {
  const $ = _c(90);
  const {
    tenant,
    fetchWithAuth
  } = useAuth();
  const [usage, setUsage] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [inviteCodes, setInviteCodes] = useState(t0);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState("");
  const [aiUsage, setAiUsage] = useState(null);
  let t1;
  if ($[1] !== fetchWithAuth) {
    t1 = () => {
      fetchWithAuth("/platform/invite-codes").then(async res => {
        if (res.ok) {
          setInviteCodes(await res.json());
        }
      });
    };
    $[1] = fetchWithAuth;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const loadCodes = t1;
  let t2;
  let t3;
  if ($[3] !== fetchWithAuth || $[4] !== loadCodes) {
    t2 = () => {
      Promise.all([fetchWithAuth("/platform/usage").then(async res_0 => {
        if (res_0.ok) {
          setUsage(await res_0.json());
        }
      }), fetchWithAuth("/platform/insights/usage").then(async res_1 => {
        if (res_1.ok) {
          setAiUsage(await res_1.json());
        }
      }), loadCodes()]).finally(() => setLoading(false));
    };
    t3 = [fetchWithAuth, loadCodes];
    $[3] = fetchWithAuth;
    $[4] = loadCodes;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  if (!tenant || loading) {
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <PageLoader />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  const pct = _temp;
  const fmtLimit = _temp2;
  let t4;
  if ($[8] !== tenant.name) {
    t4 = <h1 className="text-xl font-extrabold tracking-tight sm:text-2xl">{tenant.name}</h1>;
    $[8] = tenant.name;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== tenant.slug) {
    t5 = <code className="text-xs text-base-content/30">{tenant.slug}</code>;
    $[10] = tenant.slug;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== tenant.plan) {
    t6 = <span className="inline-flex items-center gap-1 rounded-full border border-primary/20 bg-primary/5 px-2 py-0.5 text-[10px] font-semibold text-primary">{tenant.plan}</span>;
    $[12] = tenant.plan;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold ${tenant.status === "active" ? "border border-success/20 bg-success/5 text-success" : "border border-error/20 bg-error/5 text-error"}`;
  const t8 = `h-1.5 w-1.5 rounded-full ${tenant.status === "active" ? "bg-success" : "bg-error"}`;
  let t9;
  if ($[14] !== t8) {
    t9 = <span className={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9 || $[18] !== tenant.status) {
    t10 = <span className={t7}>{t9}{tenant.status}</span>;
    $[16] = t7;
    $[17] = t9;
    $[18] = tenant.status;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t5 || $[22] !== t6) {
    t11 = <div className="mt-1.5 flex flex-wrap items-center gap-2 sm:gap-3">{t5}{t6}{t10}</div>;
    $[20] = t10;
    $[21] = t5;
    $[22] = t6;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t4) {
    t12 = <div>{t4}{t11}</div>;
    $[24] = t11;
    $[25] = t4;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = `grid gap-px overflow-hidden rounded-xl border border-white/5 bg-white/5 grid-cols-2 ${aiUsage?.enabled ? "lg:grid-cols-5" : "lg:grid-cols-4"}`;
  const t14 = usage?.interactionCount ?? 0;
  const t15 = usage?.limits.maxInteractionsPerMonth ?? tenant.maxInteractionsPerMonth;
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = <StatCell label="Interactions" value={t14} max={t15} pct={pct} fmtLimit={fmtLimit} sub="this month" />;
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const t17 = usage?.notificationCount ?? 0;
  let t18;
  if ($[30] !== t17) {
    t18 = <StatCell label="Notifications" value={t17} max={-1} pct={pct} fmtLimit={fmtLimit} sub="this month" />;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== tenant.maxDashboards) {
    t19 = fmtLimit(tenant.maxDashboards);
    $[32] = tenant.maxDashboards;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t19) {
    t20 = <LimitCell label="Dashboards" value={t19} />;
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== tenant.maxAlerts) {
    t21 = fmtLimit(tenant.maxAlerts);
    $[36] = tenant.maxAlerts;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t21) {
    t22 = <LimitCell label="Alerts" value={t21} />;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== aiUsage) {
    t23 = aiUsage?.enabled && <StatCell label="AI Tokens" value={aiUsage.used} max={aiUsage.limit} pct={pct} fmtLimit={fmtLimit} sub="this month" />;
    $[40] = aiUsage;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t13 || $[43] !== t16 || $[44] !== t18 || $[45] !== t20 || $[46] !== t22 || $[47] !== t23) {
    t24 = <div className={t13}>{t16}{t18}{t20}{t22}{t23}</div>;
    $[42] = t13;
    $[43] = t16;
    $[44] = t18;
    $[45] = t20;
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <InsightsCard />;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-base-content/30">Plan Details</p>;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== tenant.maxInteractionsPerMonth) {
    t27 = fmtLimit(tenant.maxInteractionsPerMonth);
    $[51] = tenant.maxInteractionsPerMonth;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t27) {
    t28 = {
      label: "Interactions / mo",
      value: t27
    };
    $[53] = t27;
    $[54] = t28;
  } else {
    t28 = $[54];
  }
  let t29;
  if ($[55] !== tenant.maxDashboards) {
    t29 = fmtLimit(tenant.maxDashboards);
    $[55] = tenant.maxDashboards;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  let t30;
  if ($[57] !== t29) {
    t30 = {
      label: "Dashboards",
      value: t29
    };
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== tenant.maxAlerts) {
    t31 = fmtLimit(tenant.maxAlerts);
    $[59] = tenant.maxAlerts;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== t31) {
    t32 = {
      label: "Alerts",
      value: t31
    };
    $[61] = t31;
    $[62] = t32;
  } else {
    t32 = $[62];
  }
  const t33 = tenant.retentionDays === -1 ? "\u221E" : `${tenant.retentionDays}d`;
  let t34;
  if ($[63] !== t33) {
    t34 = {
      label: "Retention",
      value: t33
    };
    $[63] = t33;
    $[64] = t34;
  } else {
    t34 = $[64];
  }
  let t35;
  if ($[65] !== t28 || $[66] !== t30 || $[67] !== t32 || $[68] !== t34) {
    t35 = <div className="rounded-xl border border-white/5 bg-base-100 p-6">{t26}<div className="grid grid-cols-2 gap-6">{[t28, t30, t32, t34].map(_temp3)}</div></div>;
    $[65] = t28;
    $[66] = t30;
    $[67] = t32;
    $[68] = t34;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  let t37;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <p className="mb-4 text-xs font-semibold uppercase tracking-widest text-base-content/30">Invite Codes</p>;
    t37 = <p className="text-xs text-base-content/40 mb-4">Share these with others to give them access to the beta.</p>;
    $[70] = t36;
    $[71] = t37;
  } else {
    t36 = $[70];
    t37 = $[71];
  }
  let t38;
  if ($[72] !== copied || $[73] !== inviteCodes) {
    t38 = <div className="rounded-xl border border-white/5 bg-base-100 p-6">{t36}{t37}{inviteCodes.length === 0 ? <p className="text-sm text-base-content/20">No invite codes available.</p> : <div className="space-y-2">{inviteCodes.map(ic => <div key={ic.codeId} className="flex items-center justify-between rounded-lg bg-base-200/50 px-4 py-2.5"><code className="font-mono text-sm font-bold tracking-widest">{ic.code}</code>{ic.isUsed ? <span className="text-xs text-base-content/20">Used</span> : <button onClick={() => {
            navigator.clipboard.writeText(`${window.location.origin}/signup?code=${ic.code}`);
            setCopied(ic.code);
            setTimeout(() => setCopied(""), 2000);
          }} className="btn btn-ghost btn-xs">{copied === ic.code ? "Copied!" : "Copy link"}</button>}</div>)}</div>}</div>;
    $[72] = copied;
    $[73] = inviteCodes;
    $[74] = t38;
  } else {
    t38 = $[74];
  }
  let t39;
  if ($[75] !== t35 || $[76] !== t38) {
    t39 = <div className="grid gap-6 lg:grid-cols-2">{t35}{t38}</div>;
    $[75] = t35;
    $[76] = t38;
    $[77] = t39;
  } else {
    t39 = $[77];
  }
  let t40;
  if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <div className="pointer-events-none absolute -inset-2 rounded-2xl bg-primary/5 blur-2xl" />;
    $[78] = t40;
  } else {
    t40 = $[78];
  }
  let t41;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <div className="flex items-center gap-2 border-b border-white/5 px-4 py-3"><span className="h-2.5 w-2.5 rounded-full bg-error/60" /><span className="h-2.5 w-2.5 rounded-full bg-warning/60" /><span className="h-2.5 w-2.5 rounded-full bg-success/60" /><span className="ml-3 font-mono text-xs text-base-content/20">quick start</span></div>;
    $[79] = t41;
  } else {
    t41 = $[79];
  }
  let t42;
  let t43;
  let t44;
  let t45;
  let t46;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <div className="text-base-content/25"># Install the CLI</div>;
    t43 = <div><span className="text-primary">$</span> npm install -g @stdiolabs/provenance-cli</div>;
    t44 = <div className="mt-2 text-base-content/25"># Configure</div>;
    t45 = <div><span className="text-primary">$</span> provenance config set apiUrl https://provenance.onrender.com/api</div>;
    t46 = <span className="text-primary">$</span>;
    $[80] = t42;
    $[81] = t43;
    $[82] = t44;
    $[83] = t45;
    $[84] = t46;
  } else {
    t42 = $[80];
    t43 = $[81];
    t44 = $[82];
    t45 = $[83];
    t46 = $[84];
  }
  let t47;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <div className="relative">{t40}<div className="relative overflow-hidden rounded-xl border border-white/5 bg-base-200/80 shadow-xl">{t41}<div className="overflow-x-auto p-4 font-mono text-[11px] leading-6 sm:p-5 sm:text-[13px] sm:leading-7">{t42}{t43}{t44}{t45}<div>{t46} provenance config set apiKey <span className="text-secondary">YOUR_API_KEY</span></div><div className="mt-2 text-base-content/25"># Track your first interaction</div><div><span className="text-primary">$</span> provenance track -r my-resource -t USER -a CREATE</div><div className="text-success">✔ Interaction recorded (14ms)</div></div></div></div>;
    $[85] = t47;
  } else {
    t47 = $[85];
  }
  let t48;
  if ($[86] !== t12 || $[87] !== t24 || $[88] !== t39) {
    t48 = <div className="space-y-6 sm:space-y-8">{t12}{t24}{t25}{t39}{t47}</div>;
    $[86] = t12;
    $[87] = t24;
    $[88] = t39;
    $[89] = t48;
  } else {
    t48 = $[89];
  }
  return t48;
}
function _temp3(item) {
  return <div key={item.label}><p className="text-xs text-base-content/30">{item.label}</p><p className="mt-1 text-xl font-bold">{item.value}</p></div>;
}
function _temp2(v) {
  return v === -1 ? "\u221E" : v.toLocaleString();
}
function _temp(val, max) {
  return max === -1 ? 0 : Math.min(100, Math.round(val / max * 100));
}
function StatCell(t0) {
  const $ = _c(16);
  const {
    label,
    value,
    max,
    pct,
    fmtLimit,
    sub
  } = t0;
  const p = pct(value, max);
  const color = p >= 90 ? "bg-error" : p >= 70 ? "bg-warning" : "bg-primary";
  let t1;
  if ($[0] !== label) {
    t1 = <p className="text-xs text-base-content/30 uppercase tracking-wider">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = value.toLocaleString();
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <p className="mt-2 text-2xl font-extrabold tracking-tight sm:text-3xl">{t2}</p>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== color || $[7] !== fmtLimit || $[8] !== max || $[9] !== p || $[10] !== sub) {
    t4 = max !== -1 ? <><div className="mt-3 h-1 w-full overflow-hidden rounded-full bg-white/5"><div className={`h-full rounded-full ${color} transition-all`} style={{
          width: `${p}%`
        }} /></div><p className="mt-2 text-xs text-base-content/20">{p}% of {fmtLimit(max)} · {sub}</p></> : <p className="mt-3 text-xs text-base-content/20">Unlimited · {sub}</p>;
    $[6] = color;
    $[7] = fmtLimit;
    $[8] = max;
    $[9] = p;
    $[10] = sub;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className="bg-base-100 p-4 sm:p-6">{t1}{t3}{t4}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
function LimitCell(t0) {
  const $ = _c(8);
  const {
    label,
    value
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <p className="text-xs text-base-content/30 uppercase tracking-wider">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== value) {
    t2 = <p className="mt-2 text-2xl font-extrabold tracking-tight sm:text-3xl">{value}</p>;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="mt-3 text-xs text-base-content/20">plan limit</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <div className="bg-base-100 p-4 sm:p-6">{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}